export const STATUS_KEYS = {
  NEW_LEADS: "new",
  NOT_ANSWERED: "not_answered",
  IN_PROCESS: "in_progress",
  NOT_RELEVANT: "not_relevant",
  DONATED: "donated",
  UNDEFINED: "",
};

export const statuses = {
  [STATUS_KEYS.UNDEFINED]: {
    nameDefault: "Undefined",
    nameKey: "donor_dashboard.my_contacts_statuses_undefined",
    color: "#FFFFFF",
    bgColor: "#000000",
  },
  [STATUS_KEYS.NEW_LEADS]: {
    nameDefault: "New Leads",
    nameKey: "donor_dashboard.my_contacts_statuses_new_leads",
    color: "#0A8EFF",
    bgColor: "#E7F0FF",
  },
  [STATUS_KEYS.NOT_ANSWERED]: {
    nameDefault: "Not Answered",
    nameKey: "donor_dashboard.my_contacts_statuses_not_answered",
    color: "#0A8EFF",
    bgColor: "#E7F0FF",
  },
  [STATUS_KEYS.IN_PROCESS]: {
    nameDefault: "In Process",
    nameKey: "donor_dashboard.my_contacts_statuses_in_process",
    color: "#E6972D",
    bgColor: "#FFE5C2",
  },
  [STATUS_KEYS.NOT_RELEVANT]: {
    nameDefault: "Not Relevant",
    nameKey: "donor_dashboard.my_contacts_statuses_not_relevant",
    color: "#EB5757",
    bgColor: "#FDE7E6",
  },
  [STATUS_KEYS.DONATED]: {
    nameDefault: "Donated",
    nameKey: "donor_dashboard.my_contacts_statuses_donated",
    color: "#0EAE0E",
    bgColor: "#DFFFE2",
  },
};

export const RELATIONSHIP_KEYS = {
  friend: "friend",
  family: "family",
  colleague: "colleague",
  other: "other",
  neighbor: "neighbor",
  closeFriend: "close_friend",
  distantFriend: "distant_friend",
  closeAcquaintance: "close_acquaintance",
  distantAcquaintance: "distant_acquaintance",
  father: "father",
  mother: "mother",
  uncle: "uncle",
  aunt: "aunt",
  brother: "brother",
  sister: "sister",
  cousinM: "cousin_m",
  cousinF: "cousin_f",
  nephew: "nephew",
  niece: "niece",
  grandson: "grandson",
  granddaughter: "grand_daughter",
  grandfather: "grandfather",
  grandmother: "grandmother",
  brotherInLaw: "brother-in-law",
  sisterInLaw: "sister-in-law",
};

export const relationships = {
  [RELATIONSHIP_KEYS.family]: {
    nameDefault: "Family",
    nameKey: "donor_dashboard.my_contacts_relationships_family",
  },
  [RELATIONSHIP_KEYS.colleague]: {
    nameDefault: "Colleague",
    nameKey: "donor_dashboard.my_contacts_relationships_colleague",
  },
  [RELATIONSHIP_KEYS.other]: {
    nameDefault: "Other",
    nameKey: "donor_dashboard.my_contacts_relationships_other",
  },
  [RELATIONSHIP_KEYS.neighbor]: {
    nameDefault: "Neighbor",
    nameKey: "donor_dashboard.my_contacts_relationships_neighbor",
  },
  [RELATIONSHIP_KEYS.friend]: {
    nameDefault: "Friend",
    nameKey: "donor_dashboard.my_contacts_relationships_friend",
  },
  [RELATIONSHIP_KEYS.closeFriend]: {
    nameDefault: "Close Friend",
    nameKey: "donor_dashboard.my_contacts_relationships_close_friend",
  },
  [RELATIONSHIP_KEYS.distantFriend]: {
    nameDefault: "Distant Friend",
    nameKey: "donor_dashboard.my_contacts_relationships_distant_friend",
  },
  [RELATIONSHIP_KEYS.closeAcquaintance]: {
    nameDefault: "Close Acquaintance",
    nameKey: "donor_dashboard.my_contacts_relationships_close_acquaintance",
  },
  [RELATIONSHIP_KEYS.distantAcquaintance]: {
    nameDefault: "Distant Acquaintance",
    nameKey: "donor_dashboard.my_contacts_relationships_distant_acquaintance",
  },
  [RELATIONSHIP_KEYS.father]: {
    nameDefault: "Father",
    nameKey: "donor_dashboard.my_contacts_relationships_father",
  },
  [RELATIONSHIP_KEYS.mother]: {
    nameDefault: "Mother",
    nameKey: "donor_dashboard.my_contacts_relationships_mother",
  },
  [RELATIONSHIP_KEYS.uncle]: {
    nameDefault: "Uncle",
    nameKey: "donor_dashboard.my_contacts_relationships_uncle",
  },
  [RELATIONSHIP_KEYS.aunt]: {
    nameDefault: "Aunt",
    nameKey: "donor_dashboard.my_contacts_relationships_aunt",
  },
  [RELATIONSHIP_KEYS.brother]: {
    nameDefault: "Brother",
    nameKey: "donor_dashboard.my_contacts_relationships_brother",
  },
  [RELATIONSHIP_KEYS.sister]: {
    nameDefault: "Sister",
    nameKey: "donor_dashboard.my_contacts_relationships_sister",
  },
  [RELATIONSHIP_KEYS.cousinM]: {
    nameDefault: "Cousin (M)",
    nameKey: "donor_dashboard.my_contacts_relationships_cousin_m",
  },
  [RELATIONSHIP_KEYS.cousinF]: {
    nameDefault: "Cousin (F)",
    nameKey: "donor_dashboard.my_contacts_relationships_cousin_f",
  },
  [RELATIONSHIP_KEYS.nephew]: {
    nameDefault: "Nephew",
    nameKey: "donor_dashboard.my_contacts_relationships_nephew",
  },
  [RELATIONSHIP_KEYS.niece]: {
    nameDefault: "Niece",
    nameKey: "donor_dashboard.my_contacts_relationships_niece",
  },
  [RELATIONSHIP_KEYS.grandson]: {
    nameDefault: "Grandson",
    nameKey: "donor_dashboard.my_contacts_relationships_grandson",
  },
  [RELATIONSHIP_KEYS.granddaughter]: {
    nameDefault: "Granddaughter",
    nameKey: "donor_dashboard.my_contacts_relationships_granddaughter",
  },
  [RELATIONSHIP_KEYS.grandfather]: {
    nameDefault: "Grandfather",
    nameKey: "donor_dashboard.my_contacts_relationships_grandfather",
  },
  [RELATIONSHIP_KEYS.grandmother]: {
    nameDefault: "Grandmother",
    nameKey: "donor_dashboard.my_contacts_relationships_grandmother",
  },
  [RELATIONSHIP_KEYS.brotherInLaw]: {
    nameDefault: "Brother-in-law",
    nameKey: "donor_dashboard.my_contacts_relationships_brother_in_law",
  },
  [RELATIONSHIP_KEYS.sisterInLaw]: {
    nameDefault: "Sister-in-law",
    nameKey: "donor_dashboard.my_contacts_relationships_sister_in_law",
  },
};

export const ACTION_KEYS = {
  ActionTypePhoneCall: "phone_call",
  ActionTypeLeftVoiceMsg: "left_voice_msg",
  ActionTypeSentWhatsApp: "sent_whatsapp",
  ActionTypeSentEmail: "sent_email",
  ActionTypePersonalMeeting: "personal_meeting",
  ActionTypeVideoCall: "video_call",
  ActionTypeSentInformation: "sent_information",
  ActionTypeRequestCallBack: "request_call_back",
  ActionTypeStatusUpdate: "status_update",
};

export const actions = {
  [ACTION_KEYS.ActionTypeStatusUpdate]: {
    nameDefault: "Status update",
    nameKey: "donor_dashboard.my_contacts_actions_status_update",
  },
  [ACTION_KEYS.ActionTypePhoneCall]: {
    nameDefault: "Phone Call",
    nameKey: "donor_dashboard.my_contacts_actions_phone_call",
  },
  [ACTION_KEYS.ActionTypeLeftVoiceMsg]: {
    nameDefault: "Left Voice Message",
    nameKey: "donor_dashboard.my_contacts_actions_left_voice_msg",
  },
  [ACTION_KEYS.ActionTypeSentWhatsApp]: {
    nameDefault: "Sent WhatsApp",
    nameKey: "donor_dashboard.my_contacts_actions_sent_whatsapp",
  },
  [ACTION_KEYS.ActionTypeSentEmail]: {
    nameDefault: "Sent Email",
    nameKey: "donor_dashboard.my_contacts_actions_sent_email",
  },
  [ACTION_KEYS.ActionTypePersonalMeeting]: {
    nameDefault: "Personal Meeting",
    nameKey: "donor_dashboard.my_contacts_actions_personal_meeting",
  },
  [ACTION_KEYS.ActionTypeVideoCall]: {
    nameDefault: "Video Call",
    nameKey: "donor_dashboard.my_contacts_actions_video_call",
  },
  [ACTION_KEYS.ActionTypeSentInformation]: {
    nameDefault: "Sent Information",
    nameKey: "donor_dashboard.my_contacts_actions_sent_information",
  },
  [ACTION_KEYS.ActionTypeRequestCallBack]: {
    nameDefault: "Request Call Back",
    nameKey: "donor_dashboard.my_contacts_actions_request_call_back",
  },
};
